module.exports = __webpack_public_path__ + "img/pic_kongyinpin.4d5005b0.svg";